import React, { Component } from "react";
import { Row, Col, Form } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import _ from "lodash";

export class Longitude_Latitude extends Component {
    constructor(props) {
        super(props);
    }

    renderInput = ({ input, label, classForm, type, meta, placeholder }) => {
        //console.log(meta)

        return (
            <div className="form-group">
                {label !== "" && !this.props.isMobile == true ? (
                    <label>{label} </label>
                ) : (
                    <label></label>
                )}
                <input
                    {...input}
                    className={classForm}
                    type={type}
                    autoComplete="off"
                    placeholder={!this.props.isMobile == true ? "" : placeholder}
                    style={
                        meta.error && meta.touched ? { border: "1px solid #ff0000" } : null
                    }
                />
                <div>{this.renderError(meta)}</div>
            </div>
        );
    };

    renderError({ error, touched }) {
        if (touched && error) {
            return <span className="text-danger">{error}</span>;
        }
    }

    onSubmit = (formValues) => {
        console.log(formValues);
    };

    render() {
        const { handleSubmit, pristine, reset, submitting } = this.props;

        return (
            <>
                {this.props.isMobile !== true ? (
                    <>
                        <h4>Longitude/Latitude</h4>
                        <hr />
                        <br></br>
                    </>
                ) : (
                    ""
                )}

                <Form onSubmit={handleSubmit(this.onSubmit)}>
                    <Row>
                        <Col
                            className={`m-2 m-sm-2  ${this.props.isMobile === true ? "pr-0 pl-0" : ""
                                }`}
                        >
                            {true ? (
                                <Field
                                    name="longitude"
                                    type="text"
                                    classForm="form-control"
                                    label="Longitude"
                                    placeholder="Longitude"
                                    component={this.renderInput}
                                />
                            ) : null}
                        </Col>

                        <Col
                            className={`m-2 m-sm-2  ${this.props.isMobile === true ? "pr-0 pl-0" : ""
                                }`}
                        >
                            {true ? (
                                <Field
                                    name="latitude"
                                    type="text"
                                    classForm="form-control"
                                    placeholder="Latitude"
                                    label="Latitude"
                                    component={this.renderInput}
                                />
                            ) : null}
                        </Col>
                    </Row>
                </Form>
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};
    
    const hasLongitude = formValues.longitude && formValues.longitude.trim() !== '';
    const hasLatitude = formValues.latitude && formValues.latitude.trim() !== '';
    
    // If either field has a value, both should be provided and valid
    if (hasLongitude || hasLatitude) {
        if (!hasLongitude) {
            errors.longitude = "Longitude is required when latitude is provided.";
        } else if (!/^[-+]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?)$/.test(formValues.longitude)) {
            errors.longitude = "Please enter correct longitude value.";
        }
        
        if (!hasLatitude) {
            errors.latitude = "Latitude is required when longitude is provided.";
        } else if (!/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(formValues.latitude)) {
            errors.latitude = "Please enter correct latitude value.";
        }
    }
    
    return errors;
};

const formWrapped = reduxForm({
    form: "longitudeLatitudeForm",
    destroyOnUnmount: false,
    validate,
})(Longitude_Latitude);

const mapStateToProps = (state) => ({
    errorMessage: {},
});

export default connect(mapStateToProps, {})(formWrapped);
